{
  "contract": "valoria.world.patch/v1",
  "baseRevision": 1,
  "operations": [
    {
      "op": "setWorld",
      "values": {
        "name": "Sunset Court",
        "description": "A quiet city court in the last light, framed by a clock-topped clubhouse and shaded benches.",
        "theme": "sunset-court",
        "gravity": 18,
        "atmosphere": {
          "skyColor": "#92768b",
          "horizonColor": "#efbea0",
          "groundColor": "#ad999d",
          "stars": false,
          "retroSun": false,
          "wireLandscape": false,
          "fogNear": 85,
          "fogFar": 190,
          "ambientIntensity": 1.7,
          "sunIntensity": 2.1
        }
      }
    },
    {
      "op": "putEntity",
      "entity": {
        "id": "sunset-court-architecture",
        "kind": "model",
        "assetId": "asset_1f1550f7b3ca35b20820847df8cad36384723cb0b6d93c43ca7fcfc5c244155e",
        "position": {
          "x": 0,
          "y": 0,
          "z": 0
        },
        "scale": {
          "x": 1,
          "y": 1,
          "z": 1
        },
        "rotation": {
          "x": 0,
          "y": 0,
          "z": 0
        },
        "color": "#ffffff",
        "capabilities": [],
        "colliders": [
          {
            "center": {
              "x": -31.5,
              "y": 0.65,
              "z": -5.5
            },
            "size": {
              "x": 0.55,
              "y": 1.3,
              "z": 64
            }
          },
          {
            "center": {
              "x": 31.5,
              "y": 0.65,
              "z": -5.5
            },
            "size": {
              "x": 0.55,
              "y": 1.3,
              "z": 64
            }
          },
          {
            "center": {
              "x": 0,
              "y": 0.65,
              "z": -37.5
            },
            "size": {
              "x": 63,
              "y": 1.3,
              "z": 0.55
            }
          },
          {
            "center": {
              "x": 0,
              "y": 0.65,
              "z": 26.5
            },
            "size": {
              "x": 63,
              "y": 1.3,
              "z": 0.55
            }
          },
          {
            "center": {
              "x": -11,
              "y": 0.63,
              "z": -3.5
            },
            "size": {
              "x": 0.18,
              "y": 1.26,
              "z": 0.18
            }
          },
          {
            "center": {
              "x": 11,
              "y": 0.63,
              "z": -3.5
            },
            "size": {
              "x": 0.18,
              "y": 1.26,
              "z": 0.18
            }
          },
          {
            "center": {
              "x": 0,
              "y": 0.56,
              "z": -3.5
            },
            "size": {
              "x": 22,
              "y": 0.95,
              "z": 0.08
            }
          },
          {
            "center": {
              "x": -19,
              "y": 1.8,
              "z": -24
            },
            "size": {
              "x": 0.7,
              "y": 3.6,
              "z": 1.1
            }
          },
          {
            "center": {
              "x": -11.4,
              "y": 1.8,
              "z": -24
            },
            "size": {
              "x": 0.7,
              "y": 3.6,
              "z": 1.1
            }
          },
          {
            "center": {
              "x": -3.8,
              "y": 1.8,
              "z": -24
            },
            "size": {
              "x": 0.7,
              "y": 3.6,
              "z": 1.1
            }
          },
          {
            "center": {
              "x": 3.8,
              "y": 1.8,
              "z": -24
            },
            "size": {
              "x": 0.7,
              "y": 3.6,
              "z": 1.1
            }
          },
          {
            "center": {
              "x": 11.4,
              "y": 1.8,
              "z": -24
            },
            "size": {
              "x": 0.7,
              "y": 3.6,
              "z": 1.1
            }
          },
          {
            "center": {
              "x": 19,
              "y": 1.8,
              "z": -24
            },
            "size": {
              "x": 0.7,
              "y": 3.6,
              "z": 1.1
            }
          },
          {
            "center": {
              "x": 0,
              "y": 3.7,
              "z": -33
            },
            "size": {
              "x": 39,
              "y": 7.4,
              "z": 0.5
            }
          },
          {
            "center": {
              "x": -19.3,
              "y": 3.7,
              "z": -28.5
            },
            "size": {
              "x": 0.5,
              "y": 7.4,
              "z": 9
            }
          },
          {
            "center": {
              "x": 19.3,
              "y": 3.7,
              "z": -28.5
            },
            "size": {
              "x": 0.5,
              "y": 7.4,
              "z": 9
            }
          },
          {
            "center": {
              "x": 0,
              "y": 7.55,
              "z": -28.5
            },
            "size": {
              "x": 40,
              "y": 0.35,
              "z": 10.8
            }
          },
          {
            "center": {
              "x": -14,
              "y": 0.58,
              "z": -29
            },
            "size": {
              "x": 2.45,
              "y": 1.16,
              "z": 0.7
            }
          },
          {
            "center": {
              "x": 14,
              "y": 0.58,
              "z": -29
            },
            "size": {
              "x": 2.45,
              "y": 1.16,
              "z": 0.7
            }
          },
          {
            "center": {
              "x": -23.5,
              "y": 1.7,
              "z": -13
            },
            "size": {
              "x": 0.28,
              "y": 3.4,
              "z": 0.28
            }
          },
          {
            "center": {
              "x": -23.5,
              "y": 1.7,
              "z": 0
            },
            "size": {
              "x": 0.28,
              "y": 3.4,
              "z": 0.28
            }
          },
          {
            "center": {
              "x": -23.5,
              "y": 1.7,
              "z": 10
            },
            "size": {
              "x": 0.28,
              "y": 3.4,
              "z": 0.28
            }
          },
          {
            "center": {
              "x": -17.5,
              "y": 1.7,
              "z": -13
            },
            "size": {
              "x": 0.28,
              "y": 3.4,
              "z": 0.28
            }
          },
          {
            "center": {
              "x": -17.5,
              "y": 1.7,
              "z": 0
            },
            "size": {
              "x": 0.28,
              "y": 3.4,
              "z": 0.28
            }
          },
          {
            "center": {
              "x": -17.5,
              "y": 1.7,
              "z": 10
            },
            "size": {
              "x": 0.28,
              "y": 3.4,
              "z": 0.28
            }
          },
          {
            "center": {
              "x": -20.5,
              "y": 0.58,
              "z": -9
            },
            "size": {
              "x": 2.45,
              "y": 1.16,
              "z": 0.7
            }
          },
          {
            "center": {
              "x": -20.5,
              "y": 0.3,
              "z": -10.9
            },
            "size": {
              "x": 5.2,
              "y": 0.6,
              "z": 1.2
            }
          },
          {
            "center": {
              "x": -20.5,
              "y": 0.58,
              "z": 3
            },
            "size": {
              "x": 2.45,
              "y": 1.16,
              "z": 0.7
            }
          },
          {
            "center": {
              "x": -20.5,
              "y": 0.3,
              "z": 1.1
            },
            "size": {
              "x": 5.2,
              "y": 0.6,
              "z": 1.2
            }
          },
          {
            "center": {
              "x": -20.5,
              "y": 3.6,
              "z": -18
            },
            "size": {
              "x": 0.6,
              "y": 7.2,
              "z": 0.6
            }
          },
          {
            "center": {
              "x": -20.5,
              "y": 0.32,
              "z": -18
            },
            "size": {
              "x": 2.5,
              "y": 0.64,
              "z": 2.5
            }
          },
          {
            "center": {
              "x": -20.5,
              "y": 3.6,
              "z": 15
            },
            "size": {
              "x": 0.6,
              "y": 7.2,
              "z": 0.6
            }
          },
          {
            "center": {
              "x": -20.5,
              "y": 0.32,
              "z": 15
            },
            "size": {
              "x": 2.5,
              "y": 0.64,
              "z": 2.5
            }
          },
          {
            "center": {
              "x": -13.8,
              "y": 2.4,
              "z": -18
            },
            "size": {
              "x": 0.45,
              "y": 5.6,
              "z": 0.45
            }
          },
          {
            "center": {
              "x": -13.8,
              "y": 2.4,
              "z": 11
            },
            "size": {
              "x": 0.45,
              "y": 5.6,
              "z": 0.45
            }
          },
          {
            "center": {
              "x": -15,
              "y": 0.56,
              "z": 6
            },
            "size": {
              "x": 1,
              "y": 1.12,
              "z": 0.65
            }
          },
          {
            "center": {
              "x": 17.5,
              "y": 1.7,
              "z": -13
            },
            "size": {
              "x": 0.28,
              "y": 3.4,
              "z": 0.28
            }
          },
          {
            "center": {
              "x": 17.5,
              "y": 1.7,
              "z": 0
            },
            "size": {
              "x": 0.28,
              "y": 3.4,
              "z": 0.28
            }
          },
          {
            "center": {
              "x": 17.5,
              "y": 1.7,
              "z": 10
            },
            "size": {
              "x": 0.28,
              "y": 3.4,
              "z": 0.28
            }
          },
          {
            "center": {
              "x": 23.5,
              "y": 1.7,
              "z": -13
            },
            "size": {
              "x": 0.28,
              "y": 3.4,
              "z": 0.28
            }
          },
          {
            "center": {
              "x": 23.5,
              "y": 1.7,
              "z": 0
            },
            "size": {
              "x": 0.28,
              "y": 3.4,
              "z": 0.28
            }
          },
          {
            "center": {
              "x": 23.5,
              "y": 1.7,
              "z": 10
            },
            "size": {
              "x": 0.28,
              "y": 3.4,
              "z": 0.28
            }
          },
          {
            "center": {
              "x": 20.5,
              "y": 0.58,
              "z": -9
            },
            "size": {
              "x": 2.45,
              "y": 1.16,
              "z": 0.7
            }
          },
          {
            "center": {
              "x": 20.5,
              "y": 0.3,
              "z": -10.9
            },
            "size": {
              "x": 5.2,
              "y": 0.6,
              "z": 1.2
            }
          },
          {
            "center": {
              "x": 20.5,
              "y": 0.58,
              "z": 3
            },
            "size": {
              "x": 2.45,
              "y": 1.16,
              "z": 0.7
            }
          },
          {
            "center": {
              "x": 20.5,
              "y": 0.3,
              "z": 1.1
            },
            "size": {
              "x": 5.2,
              "y": 0.6,
              "z": 1.2
            }
          },
          {
            "center": {
              "x": 20.5,
              "y": 3.6,
              "z": -18
            },
            "size": {
              "x": 0.6,
              "y": 7.2,
              "z": 0.6
            }
          },
          {
            "center": {
              "x": 20.5,
              "y": 0.32,
              "z": -18
            },
            "size": {
              "x": 2.5,
              "y": 0.64,
              "z": 2.5
            }
          },
          {
            "center": {
              "x": 20.5,
              "y": 3.6,
              "z": 15
            },
            "size": {
              "x": 0.6,
              "y": 7.2,
              "z": 0.6
            }
          },
          {
            "center": {
              "x": 20.5,
              "y": 0.32,
              "z": 15
            },
            "size": {
              "x": 2.5,
              "y": 0.64,
              "z": 2.5
            }
          },
          {
            "center": {
              "x": 13.8,
              "y": 2.4,
              "z": -18
            },
            "size": {
              "x": 0.45,
              "y": 5.6,
              "z": 0.45
            }
          },
          {
            "center": {
              "x": 13.8,
              "y": 2.4,
              "z": 11
            },
            "size": {
              "x": 0.45,
              "y": 5.6,
              "z": 0.45
            }
          },
          {
            "center": {
              "x": 15,
              "y": 0.56,
              "z": 6
            },
            "size": {
              "x": 1,
              "y": 1.12,
              "z": 0.65
            }
          },
          {
            "center": {
              "x": -8,
              "y": 0.6,
              "z": 13
            },
            "size": {
              "x": 0.18,
              "y": 1.2,
              "z": 0.18
            }
          },
          {
            "center": {
              "x": -8,
              "y": 1.4,
              "z": 13
            },
            "size": {
              "x": 2.5,
              "y": 1.8,
              "z": 0.3
            }
          },
          {
            "center": {
              "x": 8,
              "y": 0.6,
              "z": 13
            },
            "size": {
              "x": 0.18,
              "y": 1.2,
              "z": 0.18
            }
          },
          {
            "center": {
              "x": 8,
              "y": 1.4,
              "z": 13
            },
            "size": {
              "x": 2.5,
              "y": 1.8,
              "z": 0.3
            }
          },
          {
            "center": {
              "x": -25.5,
              "y": 0.3,
              "z": 21
            },
            "size": {
              "x": 7,
              "y": 0.6,
              "z": 2
            }
          },
          {
            "center": {
              "x": 25.5,
              "y": 0.3,
              "z": 21
            },
            "size": {
              "x": 7,
              "y": 0.6,
              "z": 2
            }
          },
          {
            "center": {
              "x": 0,
              "y": 8.75,
              "z": -30
            },
            "size": {
              "x": 5,
              "y": 2.2,
              "z": 4.5
            }
          },
          {
            "center": {
              "x": 0,
              "y": 9.94,
              "z": -30
            },
            "size": {
              "x": 5.4,
              "y": 0.22,
              "z": 4.9
            }
          }
        ]
      }
    }
  ]
}
